import Meta from './Meta';

export default class Column {

    constructor(options) 
    {   
        options = options || {};

        this.meta = null;
        if( options.hasOwnProperty('meta') ) {
            this.setMeta(options.meta);
        }

        this.id          = options.id;
        this.title       = options.title;

        this.fixed       = (options.fixed === true);
        this.fixable     = (options.fixable === true);

        this.sort        = options.sort || false;
        this.sortable    = (options.sortable === true);
        this.sortDefault = options.sortDefault || 'ASC';
    }

    setMeta(meta) {
        if( ! ( meta instanceof Meta ) ) {
            meta = new Meta(meta);
        };

        this.meta = meta;
        return this;
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/Column.js